import script from "./Step3Membership.vue?vue&type=script&setup=true&lang=js"
export * from "./Step3Membership.vue?vue&type=script&setup=true&lang=js"

import "./Step3Membership.vue?vue&type=style&index=0&id=5e6cc25e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e6cc25e"]])

export default __exports__